function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { StyledBadgesGridMobileComponent } from "./badges-grid-mobile-component.scss";
const BadgesGridMobileComponent = ({ badges })=>{
    const itemRenderer = ({ url, name })=>/*#__PURE__*/ _jsx("div", {
            className: "badge-wrapper",
            children: /*#__PURE__*/ _jsx(PictureComponent, {
                src: url,
                alt: name
            })
        });
    const carouselProps = {
        items: badges,
        itemRenderer,
        defaultIndex: Math.floor(badges.length / 2),
        infinite: false,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ _jsx(StyledBadgesGridMobileComponent, {
        className: "badges-grid-mobile-component",
        children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, carouselProps))
    });
};
export default BadgesGridMobileComponent;
